import type {EndpointDirectoryV3} from '@smart/endpoint-directory';
import type {AppModel} from '../../bff/app-model/create-app-model';

export interface FetchAppModelOptions {
  readonly endpointDirectory: EndpointDirectoryV3;
  readonly marketId: string;
  readonly languageTag: string;
}

export async function fetchAppModel(
  baseUrl: string = ``,
  options: FetchAppModelOptions,
): Promise<AppModel> {
  const {endpointDirectory, languageTag, marketId} = options;
  const {envName, preview, rotatingVerifySecret} = endpointDirectory;

  const searchParams = new URLSearchParams({
    envName,
    preview: String(preview),
    marketId,
    languageTag,
  });

  if (rotatingVerifySecret) {
    const {headerName, headerValue} = rotatingVerifySecret;

    searchParams.set(`rotatingVerifySecret`, `${headerName}:${headerValue}`);
  }

  const url = `${baseUrl}/bff/app-model?${searchParams.toString()}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw Error(`Could not fetch app model.`);
  }

  return response.json() as Promise<AppModel>;
}
